/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

import React, { useMemo, useState } from 'react';
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
import { useAuth } from '../../contexts/auth';
import './user-panel.scss';
import { Popup } from 'devextreme-react';
import { ProfileForm } from './profileform';

const UserPanel = function({ menuMode }) {
  const { user, logOut } = useAuth();
  const [visible, setVisible] = useState(false);
  const menuItems = useMemo(
    () => [
      {
        text: 'Profile',
        icon: 'user',
        onClick: () => setVisible(!visible),
      },
      {
        text: 'Logout',
        icon: 'runner',
        onClick: logOut,
      },
    ],
    [logOut],
  );
  return (
    <div>
      <div className={'user-info'} data-cy="H-Profile-Link">
        <span className={'user-name '}>{user.userdetail.email} </span>
        <span className="dx-icon-chevrondown "></span>
      </div>

      {menuMode === 'context' && (
        <ContextMenu
          items={menuItems}
          data-cy="H-UserName-Button"
          target={'.user-button'}
          showEvent={'dxclick'}
          width={210}
          cssClass={'user-menu'}>
          <Position my={'top center'} at={'bottom center'} />
        </ContextMenu>
      )}
      {menuMode === 'list' && (
        <List className={'dx-toolbar-menu-action'} items={menuItems} />
      )}
      {visible && (
        <Popup
          visible={visible}
          onHidden={() => setVisible(!visible)}
          title="Profile"
          width={800}
          height={320}>
          <ProfileForm user={user} setVisible={setVisible} />
        </Popup>
      )}
    </div>
  );
};

export default UserPanel;

UserPanel.displayName = 'UserPanel';
